module.exports = __webpack_public_path__ + "static/37-94bb102f66e0871a2b8f2b7143434d65.png";